// Copyright (c) 2025 Deere & Company

import RgaSearchResults from './rga-search-result';
import t from 'tcomb';

const RgaSearchResultList = t.list(RgaSearchResults, 'RgaSearchResults');

export const getDefaultState = () => new RgaSearchResultList([]);

export default RgaSearchResultList;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/state/rga-search-result-list.js